import React from 'react';

import { LanguageType } from '../../../common/pokCore/validation/enums';

interface LanguageSwitcherProps {
  currentLanguage: string;
  isPreview: boolean;
  onLanguageChange: (language: string) => void;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  currentLanguage,
  isPreview,
  onLanguageChange,
}) => {
  const languages = [
    { code: LanguageType.PL, full: 'plProjects' },
    { code: LanguageType.EN, full: 'enProjects' },
  ];

  const handleLanguageChange = (langCode: LanguageType) => {
    const langFull = languages.find(l => l.code === langCode)?.full;
    if (langFull) {
      onLanguageChange(langCode);
    }
  };

  return (
    <div
      className={`language-switcher-wrapper ${isPreview ? 'language-switcher-preview' : ''}`}
    >
      <div className="language-switcher">
        {languages.map(lang => (
          <button
            key={lang.code}
            type="button"
            onClick={() => handleLanguageChange(lang.code)}
            className={`language-switcher-btn ${currentLanguage === lang.code ? 'active' : ''}`}
          >
            {lang.code}
          </button>
        ))}
      </div>
    </div>
  );
};
